const BaseComponent = require('base/base-component');

class guideMenu extends BaseComponent {
  constructor () {
    super({
      events: {
        'click .tab': 'switchTab'
      }
    });
  }
  init () {
    super.init();
    this.$more = this.$el.find('.to-more');
    this.$tabs = this.$el.find('.nav .tab');
  }
  switchTab (e) {
    const $target = $(e.target || e.srcElement);
    const index = $target.index();

    const $content = $target.closest('.nav').siblings('.content');
    $target.addClass('active').siblings('.tab').removeClass('active');
    $content.removeClass('show');
    $content.eq(index).addClass('show');
  }
}
module.exports = guideMenu;
